import { useEffect, useState } from 'react';
import useNoodleApi from '@/hooks/useNoodleApi';
import getAiAgents from '@/tsClient/questionnaires/getAiAgents';

export type AiAgent = Awaited<ReturnType<typeof getAiAgents>>['items'][number];

const useLoadAiAgents = ({ creatorId, questionnaireTemplateId }: {
  creatorId: string;
  questionnaireTemplateId: string;
}): AiAgent[] | null => {
  const [aiAgentsLoaded, setAiAgentsLoaded] = useState(false);
  const { data: response, getData: getAiAgentsFn } = useNoodleApi(getAiAgents);

  useEffect(() => {
    const getAgents = async (): Promise<void> => {
      if (creatorId) {
        setAiAgentsLoaded(false);
        await getAiAgentsFn({
          creatorId,
          page: 1,
          perPage: 100_000,
          questionnaireTemplateId,
        });
        setAiAgentsLoaded(true);
      }
    };
    getAgents();
  }, [getAiAgentsFn, creatorId, questionnaireTemplateId]);

  return aiAgentsLoaded && response ? response.items : null;
};

export default useLoadAiAgents;